module.exports = __webpack_public_path__ + "img/ASAN_04.817276a9.png";